// extracted by mini-css-extract-plugin
export default {"MainLayoutWrapper":"Wrapper_MainLayoutWrapper__orHyz"};